
export function parseAts(qqsstttrrWmM) {
    if (/^\d\d-\d\d-\d\d\d-\d\d-W\dM/.test(qqsstttrrWmM)) {
        // lsd
        let parts = qqsstttrrWmM.split('-')
        const lsd = Number(parts[0])
        const sec = Number(parts[1])
        const twp = Number(parts[2])
        const rge = Number(parts[3])
        const meridian = Number(parts[4].charAt(1))
        return {lsd, sec, twp, rge, meridian}
    }
    else if (/^[N,S][W,E]-\d\d-\d\d\d-\d\d-W\dM/.test(qqsstttrrWmM)) {
        // quarter section
        let parts = qqsstttrrWmM.split('-')
        const quarter = parts[0]
        const sec = Number(parts[1])
        const twp = Number(parts[2])
        const rge = Number(parts[3])
        const meridian = Number(parts[4].charAt(1))
        return {quarter, sec, twp, rge, meridian}
    }
    // else if (/\d\d-\d\d\d-\d\d-W\dM/.test(qqsstttrrWm)) {
    //     // full section
    //     let parts = qqsstttrrWm.split('-')
    //     const sec = Number(parts[0])
    //     const twp = Number(parts[1])
    //     const rge = Number(parts[2])
    //     const meridian = Number(parts[3].charAt(1))
    //     return {sec, twp, rge, meridian}
    // }
    throw new Error(`Could not parse ATS Quarter Section or LSD from ${qqsstttrrWmM}, expected format to be one of 'QQ-SS-TTT-RR-WmM', 'LS-SS-TTT-RR-WmM'`)
}
